import styled from 'styled-components';
import { assetTheme as t } from './assetTheme';

// Pill-shaped button matching the Hub prototype's action buttons
export default styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${t.fontFamily};
  font-size: 14px;
  font-weight: 700;
  border-radius: 999px;
  padding: 10px 18px;
  cursor: pointer;
  white-space: nowrap;
  border: 1px solid ${({ $primary }) => $primary ? t.midnight : t.borderStrong};
  background: ${({ $primary }) => $primary ? t.midnight : t.surface};
  color: ${({ $primary }) => $primary ? '#ffffff' : t.text};

  &:hover {
    background: ${({ $primary }) => $primary ? '#0a2438' : t.card2};
  }
`
